module.exports = __webpack_public_path__ + "static/media/Buy.5648d43d.png";